import { Alert, Box } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import VendorAuthGate from "./components/VendorAuthGate";
import VendorPortalShell from "./components/VendorPortalShell";
import VendorOnboarding from "./index";

function VendorOnboardingRouter() {
  const [searchParams] = useSearchParams();
  const taskId = searchParams.get("task_id") ?? searchParams.get("taskId");

  if (!taskId) {
    return (
      <VendorPortalShell>
        <Box sx={{ maxWidth: 560, mx: "auto", mt: 8, p: 3 }}>
          <Alert severity="info">
            This link requires a task_id from your invitation email. If you
            didn&apos;t receive one, contact your Vendor Manager.
          </Alert>
        </Box>
      </VendorPortalShell>
    );
  }

  return (
    <VendorAuthGate>
      <VendorPortalShell>
        <VendorOnboarding />
      </VendorPortalShell>
    </VendorAuthGate>
  );
}

export default VendorOnboardingRouter;
